import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { getUserData } from "../../helpers/utils";
import api from "../../Api";
import { useHistory } from "react-router-dom";
const AdminDashboard = () => {
  const User = getUserData();
  const [Data, setData] = useState([]);
  const [data, setdata] = useState([]);
  const history = useHistory();
  useEffect(() => {
    const userid = User._id;
    async function getjobs() {
      try {
        const response = await api.saveAllJob(userid);
        if (response.status !== 400) {
          // setjobData(response.savedJobs);
        } else if (response.status == 400) {
        }
      } catch (error) {
        console.error(error);
      }
    }
    getjobs();

    async function getcandidateDashboard() {
      try {
        const response = await api.getcandidatedashboard();
        if (response.status !== 400) {
          setData(response);
          setdata(response?.recentApplications);
        } else if (response.status == 400) {
        }
      } catch (error) {
        console.error(error);
      }
    }
    getcandidateDashboard();
  }, []);
  const formatNumber = (num) => {
    if (num >= 1000 && num < 1000000) {
      return `${(num / 1000).toFixed(1)}K`;
    } else if (num >= 1000000) {
      return `${(num / 1000000).toFixed(1)}M`;
    }
    return num;
  };

  const columns = [
    {
      name: "Job Title",
      selector: (row) => (
        <div>
          <div style={{ color: "#003366", fontSize: "14px", fontWeight: 600 }}>
            {row?.jobId?.title}
          </div>
          <div>{row?.jobId?.company.name}</div>
        </div>
      ),
      sortable: true,
    },
    // {
    //   name: "Company",
    //   selector: (row) => row?.jobId?.company.name,
    //   sortable: true,
    // },
    {
      name: "Status",
      selector: (row) => row.status,
      sortable: true,
    },
    {
      name: "Applied On",
      selector: (row) => new Date(row?.appliedAt).toISOString().split("T")[0],
      sortable: true,
    },
    // http://localhost:3001/jobs/66e2b18f56eeb7b478093333?job=Salon-Manager&company=CPBA
    {
      name: "Actions",
      cell: (row) => (
        <button
          className=" ViewDetails-btn text-white xl:px-4 md:px-2 py-2  px-2 m-auto"
          onClick={() =>
            history.push(`/jobs/${row?.jobId._id}?job=${row?.jobId?.title}`)
          }
        >
          View Details
        </button>
      ),
    },
  ];

  const tableData = {
    columns,
    data,
  };

  return (
    <div className="md:p-8 p-8 pt-0 ">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
        <div className="dashboardsection-card flex  justify-center gap-3">
          <div className="dashboardsection-image ">
            <svg
              width="42"
              height="42"
              viewBox="0 0 42 42"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_197_901)">
                <path
                  d="M42 26.2502V42.0002H21V26.2502H26.25V21.0002H36.75V26.2502H42ZM28.875 26.2502H34.125V23.6252H28.875V26.2502ZM39.375 34.1252H36.75V36.7502H34.125V34.1252H28.875V36.7502H26.25V34.1252H23.625V39.3752H39.375V34.1252ZM39.375 28.8752H23.625V31.5002H39.375V28.8752ZM32.0947 18.3752C31.3564 17.5412 30.4814 16.8986 29.4697 16.4474C28.458 15.9962 27.3848 15.7638 26.25 15.7502C25.1562 15.7502 24.1377 15.9552 23.1943 16.3654C22.251 16.7755 21.417 17.3361 20.6924 18.047C19.9678 18.758 19.4004 19.5988 18.9902 20.5695C18.5801 21.5402 18.375 22.5587 18.375 23.6252C18.375 24.883 18.0947 26.0656 17.5342 27.173C16.9736 28.2804 16.1807 29.2101 15.1553 29.9621C15.7705 30.2765 16.3447 30.6388 16.8779 31.049C17.4111 31.4591 17.9102 31.924 18.375 32.4435V39.3752C18.375 38.2951 18.1699 37.2765 17.7598 36.3195C17.3496 35.3625 16.7891 34.5285 16.0781 33.8175C15.3672 33.1066 14.5264 32.5392 13.5557 32.1154C12.585 31.6916 11.5664 31.4865 10.5 31.5002C9.40625 31.5002 8.3877 31.7052 7.44434 32.1154C6.50098 32.5255 5.66699 33.0861 4.94238 33.797C4.21777 34.508 3.65039 35.3488 3.24023 36.3195C2.83008 37.2902 2.625 38.3087 2.625 39.3752H0C0 38.3771 0.136719 37.4132 0.410156 36.4836C0.683594 35.5539 1.07324 34.672 1.5791 33.838C2.08496 33.0041 2.7002 32.2658 3.4248 31.6232C4.14941 30.9806 4.95605 30.4269 5.84473 29.9621C4.83301 29.2238 4.04688 28.3009 3.48633 27.1935C2.92578 26.0861 2.63867 24.8966 2.625 23.6252C2.625 22.5451 2.83008 21.5265 3.24023 20.5695C3.65039 19.6125 4.21094 18.7785 4.92188 18.0675C5.63281 17.3566 6.4668 16.7892 7.42383 16.3654C8.38086 15.9416 9.40625 15.7365 10.5 15.7502C11.7578 15.7502 12.9404 16.0304 14.0479 16.591C15.1553 17.1515 16.085 17.9445 16.8369 18.9699C17.3564 17.9445 18.0195 17.0285 18.8262 16.2218C19.6328 15.4152 20.5557 14.7453 21.5947 14.2121C20.583 13.4738 19.7969 12.5509 19.2363 11.4435C18.6758 10.3361 18.3887 9.14664 18.375 7.87515C18.375 6.79507 18.5801 5.77652 18.9902 4.81949C19.4004 3.86246 19.9609 3.02847 20.6719 2.31754C21.3828 1.6066 22.2168 1.03922 23.1738 0.615387C24.1309 0.191559 25.1562 -0.0135193 26.25 0.000152588C27.3301 0.000152588 28.3486 0.205231 29.3057 0.615387C30.2627 1.02554 31.0967 1.58609 31.8076 2.29703C32.5186 3.00797 33.0859 3.84879 33.5098 4.81949C33.9336 5.79019 34.1387 6.80875 34.125 7.87515C34.125 9.13297 33.8447 10.3156 33.2842 11.423C32.7236 12.5304 31.9307 13.4601 30.9053 14.2121C31.835 14.6769 32.6758 15.258 33.4277 15.9552C34.1797 16.6525 34.8154 17.4591 35.335 18.3752H32.0947ZM10.5 28.8752C11.2246 28.8752 11.9014 28.7384 12.5303 28.465C13.1592 28.1916 13.7197 27.8156 14.2119 27.3371C14.7041 26.8586 15.0801 26.3048 15.3398 25.6759C15.5996 25.047 15.7363 24.3634 15.75 23.6252C15.75 22.9005 15.6133 22.2238 15.3398 21.5949C15.0664 20.966 14.6904 20.4054 14.2119 19.9132C13.7334 19.4211 13.1797 19.0451 12.5508 18.7853C11.9219 18.5255 11.2383 18.3888 10.5 18.3752C9.77539 18.3752 9.09863 18.5119 8.46973 18.7853C7.84082 19.0587 7.28027 19.4347 6.78809 19.9132C6.2959 20.3918 5.91992 20.9455 5.66016 21.5744C5.40039 22.2033 5.26367 22.8869 5.25 23.6252C5.25 24.3498 5.38672 25.0265 5.66016 25.6554C5.93359 26.2843 6.30957 26.8449 6.78809 27.3371C7.2666 27.8293 7.82031 28.2052 8.44922 28.465C9.07812 28.7248 9.76172 28.8615 10.5 28.8752ZM21 7.87515C21 8.59976 21.1367 9.27652 21.4102 9.90543C21.6836 10.5343 22.0596 11.0949 22.5381 11.5871C23.0166 12.0793 23.5703 12.4552 24.1992 12.715C24.8281 12.9748 25.5117 13.1115 26.25 13.1252C26.9746 13.1252 27.6514 12.9884 28.2803 12.715C28.9092 12.4416 29.4697 12.0656 29.9619 11.5871C30.4541 11.1086 30.8301 10.5548 31.0898 9.92593C31.3496 9.29703 31.4863 8.61343 31.5 7.87515C31.5 7.15054 31.3633 6.47379 31.0898 5.84488C30.8164 5.21597 30.4404 4.65543 29.9619 4.16324C29.4834 3.67105 28.9297 3.29507 28.3008 3.03531C27.6719 2.77554 26.9883 2.63882 26.25 2.62515C25.5254 2.62515 24.8486 2.76187 24.2197 3.03531C23.5908 3.30875 23.0303 3.68472 22.5381 4.16324C22.0459 4.64175 21.6699 5.19547 21.4102 5.82437C21.1504 6.45328 21.0137 7.13687 21 7.87515Z"
                  fill="#ffffff"
                />
              </g>
              <defs>
                <clipPath id="clip0_197_901">
                  <rect width="42" height="42" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </div>
          <div>
            <h2 className="">Total Applications</h2>
            <p className="text-center ">
              {formatNumber(
                Data?.totalApplications != undefined &&
                  Data?.totalApplications != null
                  ? Data?.totalApplications
                  : "0"
              )}
            </p>
          </div>
        </div>
        <div
          className="dashboardsection-card flex md:gap-2 justify-center lg:gap-3"
          onClick={(e) => history.push("/dashboard/job-saved")}
        >
          <div className="dashboardsection-image ">
            <svg
              width="42"
              height="42"
              viewBox="0 0 42 42"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M42 34.125V31.5H39.2424C39.0722 30.6787 38.746 29.8977 38.2817 29.1992L40.2373 27.2436L38.3814 25.3877L36.4258 27.3433C35.7273 26.879 34.9463 26.5528 34.125 26.3826V23.625H31.5V26.3826C30.6787 26.5528 29.8977 26.879 29.1992 27.3433L27.2436 25.3877L25.3877 27.2436L27.3433 29.1992C26.879 29.8977 26.5528 30.6787 26.3826 31.5H23.625V34.125H26.3826C26.5532 34.9611 26.8866 35.7381 27.3433 36.4258L25.3877 38.3814L27.2436 40.2373L29.1992 38.2817C29.8977 38.746 30.6787 39.0722 31.5 39.2424V42H34.125V39.2424C34.9463 39.0722 35.7273 38.746 36.4258 38.2817L38.3814 40.2373L40.2373 38.3814L38.2817 36.4258C38.746 35.7273 39.0722 34.9463 39.2424 34.125H42ZM32.8125 36.75C30.6416 36.75 28.875 34.9834 28.875 32.8125C28.875 30.6416 30.6416 28.875 32.8125 28.875C34.9834 28.875 36.75 30.6416 36.75 32.8125C36.75 34.9834 34.9834 36.75 32.8125 36.75ZM26.25 22.3125H15.75C15.0538 22.3125 14.3861 22.0359 13.8938 21.5437C13.4016 21.0514 13.125 20.3837 13.125 19.6875V5.25C13.125 4.55381 13.4016 3.88613 13.8938 3.39384C14.3861 2.90156 15.0538 2.625 15.75 2.625H26.25C26.9462 2.625 27.6139 2.90156 28.1062 3.39384C28.5984 3.88613 28.875 4.55381 28.875 5.25V19.6875C28.875 20.3837 28.5984 21.0514 28.1062 21.5437C27.6139 22.0359 26.9462 22.3125 26.25 22.3125ZM15.75 19.6875H26.25V5.25H15.75V19.6875Z"
                fill="#ffffff"
              />
              <path
                d="M22.3125 27.5625H10.5C9.80381 27.5625 9.13613 27.2859 8.64384 26.7937C8.15156 26.3014 7.875 25.6337 7.875 24.9375V9.1875H10.5V24.9375H22.3125V27.5625Z"
                fill="#ffffff"
              />
              <path
                d="M17.0625 32.8125H5.25C3.80231 32.8125 2.625 31.6352 2.625 30.1875V14.4375H5.25V30.1875H17.0625V32.8125Z"
                fill="#ffffff"
              />
            </svg>
          </div>
          <div>
            <h2 className="">Saved Jobs</h2>
            <p className="text-center">
              {formatNumber(
                Data?.savedJobs?.length > 0 ? Data?.savedJobs?.length : "0"
              )}
            </p>
          </div>
        </div>
        <div className="dashboardsection-card flex md:gap-1 justify-center lg:gap-3">
          <div className="dashboardsection-image ">
            <svg
              width="42"
              height="42"
              viewBox="0 0 42 42"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12.25 14.875L15.75 11.375L12.25 7.875L8.75 11.375L12.25 14.875ZM7 24.5C6.0375 24.5 5.21383 24.1576 4.529 23.4727C3.84417 22.7879 3.50117 21.9637 3.5 21V5.25C3.5 4.2875 3.843 3.46383 4.529 2.779C5.215 2.09417 6.03867 1.75117 7 1.75H35C35.9625 1.75 36.7868 2.093 37.4728 2.779C38.1587 3.465 38.5012 4.28867 38.5 5.25V21C38.5 21.9625 38.1576 22.7868 37.4728 23.4727C36.7879 24.1588 35.9637 24.5012 35 24.5H29.3562C29.5312 23.9167 29.6479 23.3333 29.7063 22.75C29.7646 22.1667 29.7646 21.5833 29.7063 21H35V5.25H7V21H12.2937C12.2354 21.5833 12.2354 22.1667 12.2937 22.75C12.3521 23.3333 12.4688 23.9167 12.6438 24.5H7ZM28.875 12.25C29.6042 12.25 30.2242 11.9951 30.7352 11.4853C31.2463 10.9754 31.5012 10.3553 31.5 9.625C31.4988 8.89467 31.2439 8.27517 30.7352 7.7665C30.2266 7.25783 29.6065 7.00233 28.875 7C28.1435 6.99767 27.524 7.25317 27.0165 7.7665C26.509 8.27983 26.2535 8.89933 26.25 9.625C26.2465 10.3507 26.502 10.9708 27.0165 11.4853C27.531 11.9998 28.1505 12.2547 28.875 12.25ZM8.75 40.25V36.575C8.75 35.5542 9.03467 34.6063 9.604 33.7312C10.1733 32.8562 10.9241 32.2 11.8562 31.7625C13.2854 31.0917 14.7729 30.5888 16.3187 30.254C17.8646 29.9192 19.425 29.7512 21 29.75C22.575 29.7488 24.1354 29.9168 25.6812 30.254C27.2271 30.5912 28.7146 31.094 30.1438 31.7625C31.0771 32.2 31.8284 32.8562 32.3978 33.7312C32.9671 34.6063 33.2512 35.5542 33.25 36.575V40.25H8.75ZM12.25 36.75H29.75V36.575C29.75 36.225 29.6479 35.9042 29.4438 35.6125C29.2396 35.3208 28.9771 35.1021 28.6562 34.9562C27.4312 34.4021 26.1771 33.9792 24.8938 33.6875C23.6104 33.3958 22.3125 33.25 21 33.25C19.6875 33.25 18.3896 33.3958 17.1062 33.6875C15.8229 33.9792 14.5688 34.4021 13.3438 34.9562C13.0229 35.1021 12.7604 35.3208 12.5563 35.6125C12.3521 35.9042 12.25 36.225 12.25 36.575V36.75ZM21 28C19.3083 28 17.8646 27.4021 16.6687 26.2063C15.4729 25.0104 14.875 23.5667 14.875 21.875C14.875 20.1833 15.4729 18.7396 16.6687 17.5437C17.8646 16.3479 19.3083 15.75 21 15.75C22.6917 15.75 24.1354 16.3479 25.3313 17.5437C26.5271 18.7396 27.125 20.1833 27.125 21.875C27.125 23.5667 26.5271 25.0104 25.3313 26.2063C24.1354 27.4021 22.6917 28 21 28ZM21 24.5C21.7292 24.5 22.3492 24.2451 22.8602 23.7352C23.3713 23.2254 23.6262 22.6053 23.625 21.875C23.6238 21.1447 23.3689 20.5252 22.8602 20.0165C22.3516 19.5078 21.7315 19.2523 21 19.25C20.2685 19.2477 19.649 19.5032 19.1415 20.0165C18.634 20.5298 18.3785 21.1493 18.375 21.875C18.3715 22.6007 18.627 23.2207 19.1415 23.7352C19.656 24.2498 20.2755 24.5047 21 24.5Z"
                fill="#ffffff"
              />
            </svg>
          </div>
          <div>
            <h2 className="">Profile Completeness</h2>
            <p className="text-center">
              {formatNumber(
                Data?.profileCompleteness != undefined &&
                  Data?.profileCompleteness != null
                  ? Data?.profileCompleteness
                  : "0"
              )}
              %
            </p>
          </div>
        </div>
      </div>
      <div className="bg-white p-4 rounded-lg shadow">
        <h2 className="text-lg Applications-table font-bold mb-4">
          Recent Applications
        </h2>
        <DataTableExtensions {...tableData}>
          <DataTable
            columns={columns}
            data={data}
            defaultSortField="id"
            defaultSortAsc={false}
            pagination
            highlightOnHover
          />
        </DataTableExtensions>
      </div>
    </div>
  );
};

export default AdminDashboard;
